module.exports = __webpack_public_path__ + "media/assets/images/rain_later_will_sunny-a89ee9e4d96f1edb8f5a6df6f7a156d2.png";